/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as ProcedureService} from "../../../Services/ProcedureService";

export class ProcedureFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			procedures: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		ProcedureService.Get()
			.then((x) => {
				this.setState({procedures: x.result});
			});
	}

	@autobind
	getProcedure() {
		return this.state.procedures.find((x) => x.procedureId == this.props.Value);
	}

	@autobind
	_render() {
		return this.getProcedure() ? this.getProcedure().name : "N/A";
	}
}